export default [
  {
    path: '/explore',
    name: 'mastery#tagSearch#index',
    component: () => import(/* webpackChunkName: "tagSearch/index" */ '@views/tag-search/index'),
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
];
